document.querySelectorAll('[data-trendha-help]').forEach(help => {
  if (help.dataset.ready) return
  help.dataset.ready = 'true'
  const search = help.querySelector('[data-help-search]')
  search.addEventListener('input', () => {
    const term = search.value.trim().toLocaleLowerCase()
    let count = 0
    help.querySelectorAll('[data-help-question]').forEach(question => {
      const matches = question.textContent.toLocaleLowerCase().includes(term)
      question.hidden = !matches
      if (matches) count++
    })
    help.querySelectorAll('.th-help-group').forEach(group => {
      group.hidden = !Array.from(group.querySelectorAll('[data-help-question]')).some(question => !question.hidden)
    })
    help.querySelector('[data-help-empty]').hidden = count > 0
  })
  help.querySelectorAll('nav a').forEach(link => link.addEventListener('click', () => {
    search.value = ''
    search.dispatchEvent(new Event('input'))
  }))
})
